import React from "react";

const Bio = () => {
  return (
    <p
      className="text-center shimmer-text mt-2 px-4 text-xs md:text-sm italic font-medium tracking-wide
                 bg-gradient-to-r from-fuchsia-400 via-indigo-500 to-pink-500
                 bg-clip-text text-transparent drop-shadow-[0_0_3px_rgba(255,255,255,0.6)]"
    >
      BS Computer Science | Data Analyst | Gujrat, Pakistan
    </p>
    
  );
};

export default Bio;
